export interface Actress {
  id: string;
  name: string;
  nameRomaji: string;
  nameKana: string;
  portrait: string;
  birthDate: string;
  age: number;
  debutYear: number;
  status: "活跃" | "休业";
  agency: string;
  height: string;
  hometown: string;
  genres: string[];
  featuredWorks: string[];
  bio: string;
  worksCount: number;
  popularity: number;
}

export const actresses: Actress[] = [
  {
    id: "a01",
    name: "绫濑真央",
    nameRomaji: "Ayase Mao",
    nameKana: "あやせ まお",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20thirties%20wearing%20a%20tailored%20cream%20blazer%2C%20soft%20diffused%20studio%20lighting%2C%20warm%20beige%20seamless%20background%2C%20subtle%20film%20grain%2C%20high-end%20magazine%20photography%2C%20natural%20makeup%2C%20calm%20confident%20expression%2C%20shallow%20depth%20of%20field&width=600&height=800&seq=actress-portrait-01&orientation=portrait",
    birthDate: "1994-03-18",
    age: 32,
    debutYear: 2015,
    status: "活跃",
    agency: "星野企划",
    height: "165cm",
    hometown: "东京都",
    genres: ["文艺剧情", "都市情感", "时代剧"],
    featuredWorks: ["盛夏的最后一封信", "东京的四个季节", "白夜的花火"],
    bio: "以沉稳细腻的表演风格受到关注，擅长处理人物内心层次丰富的角色。出道十余年间横跨电影、电视剧与舞台领域，被媒体称为「安静的叙述者」。近年转向更具作者性的文艺作品，并参与剧本企划。",
    worksCount: 86,
    popularity: 98,
  },
  {
    id: "a02",
    name: "水城彩",
    nameRomaji: "Mizuki Aya",
    nameKana: "みずき あや",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20late%20twenties%20with%20shoulder-length%20dark%20hair%2C%20wearing%20a%20soft%20ivory%20knit%20top%2C%20warm%20neutral%20studio%20backdrop%2C%20gentle%20window%20light%2C%20understated%20fashion%20magazine%20photography%2C%20quiet%20graceful%20expression%2C%20fine%20film%20texture&width=600&height=800&seq=actress-portrait-02&orientation=portrait",
    birthDate: "1998-07-02",
    age: 28,
    debutYear: 2018,
    status: "活跃",
    agency: "白鹭制作",
    height: "162cm",
    hometown: "神奈川县",
    genres: ["悬疑", "文艺剧情", "都市情感"],
    featuredWorks: ["雨夜列车", "玻璃与光"],
    bio: "以冷调气质与精准的情绪控制见长，常出演带有悬疑色彩的独立电影。曾凭《玻璃与光》中的配角获得影评人协会新人赏，被认为是最具作者电影缘的演员之一。",
    worksCount: 64,
    popularity: 92,
  },
  {
    id: "a03",
    name: "白石莉子",
    nameRomaji: "Shiraishi Riko",
    nameKana: "しらいし りこ",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20mid%20twenties%20with%20straight%20black%20hair%20and%20soft%20bangs%2C%20wearing%20a%20pale%20beige%20shirt%2C%20warm%20sand%20colored%20studio%20background%2C%20diffused%20softbox%20lighting%2C%20clean%20minimal%20portrait%20photography%2C%20subtle%20smile%2C%20natural%20beauty%20makeup&width=600&height=800&seq=actress-portrait-03&orientation=portrait",
    birthDate: "2001-11-09",
    age: 24,
    debutYear: 2020,
    status: "活跃",
    agency: "蓝光娱乐",
    height: "158cm",
    hometown: "大阪府",
    genres: ["青春", "爱情喜剧", "文艺剧情"],
    featuredWorks: ["盛夏的最后一封信", "第七次告白", "白夜的花火"],
    bio: "关西出身的新生代演员，以清透的镜头感和自然的台词节奏受到年轻观众欢迎。作品多聚焦青春成长题材，同时在网络剧领域积累了稳定口碑。",
    worksCount: 48,
    popularity: 89,
  },
  {
    id: "a04",
    name: "高梨沙耶",
    nameRomaji: "Takanashi Saya",
    nameKana: "たかなし さや",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20mid%20thirties%20with%20a%20low%20chignon%20hairstyle%2C%20wearing%20a%20soft%20camel%20coat%2C%20warm%20taupe%20studio%20background%2C%20cinematic%20side%20lighting%2C%20sophisticated%20fashion%20editorial%20photography%2C%20poised%20serene%20expression%2C%20fine%20grain&width=600&height=800&seq=actress-portrait-04&orientation=portrait",
    birthDate: "1992-01-27",
    age: 34,
    debutYear: 2012,
    status: "活跃",
    agency: "蓝光娱乐",
    height: "168cm",
    hometown: "北海道",
    genres: ["治愈", "文艺剧情", "群像"],
    featuredWorks: ["海边的旧书店"],
    bio: "出道超过十年的实力派，早期以电视剧配角起步，近年凭借生活流电影中的克制演出获得广泛认可。喜欢阅读与旅行，常参与作品的地方取景企划。",
    worksCount: 102,
    popularity: 90,
  },
  {
    id: "a05",
    name: "神宫寺葵",
    nameRomaji: "Jinguji Aoi",
    nameKana: "じんぐうじ あおい",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20thirties%20with%20short%20dark%20bob%20hair%2C%20wearing%20a%20deep%20burgundy%20blouse%2C%20muted%20greige%20studio%20backdrop%2C%20soft%20directional%20lighting%2C%20minimal%20high%20fashion%20portrait%2C%20composed%20thoughtful%20expression%2C%20subtle%20film%20texture&width=600&height=800&seq=actress-portrait-05&orientation=portrait",
    birthDate: "1996-05-14",
    age: 30,
    debutYear: 2016,
    status: "活跃",
    agency: "东洋艺能",
    height: "166cm",
    hometown: "京都府",
    genres: ["悬疑", "都市情感", "群像"],
    featuredWorks: ["无声的房间", "东京的四个季节"],
    bio: "气质清冷，擅长塑造带有秘密感的人物。除影视演出外也活跃于有声书朗读与舞台剧，声音表现力被视为其标志之一。",
    worksCount: 73,
    popularity: 94,
  },
  {
    id: "a06",
    name: "三浦千夏",
    nameRomaji: "Miura Chinatsu",
    nameKana: "みうら ちなつ",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20late%20twenties%20with%20wavy%20chestnut%20hair%2C%20wearing%20a%20light%20mocha%20trench%20coat%2C%20warm%20cream%20studio%20background%2C%20soft%20even%20lighting%2C%20refined%20lifestyle%20magazine%20photography%2C%20warm%20approachable%20expression%2C%20delicate%20film%20grain&width=600&height=800&seq=actress-portrait-06&orientation=portrait",
    birthDate: "1997-09-30",
    age: 29,
    debutYear: 2019,
    status: "活跃",
    agency: "东洋艺能",
    height: "163cm",
    hometown: "福冈县",
    genres: ["悬疑", "剧情", "爱情"],
    featuredWorks: ["雨夜列车", "她的第二个名字"],
    bio: "以稳定的一年多部作品产量著称，角色跨度从职场女性到悬疑作品中的关键人物。访谈中常提及对九州故乡的眷恋，并参与地方影像推广。",
    worksCount: 69,
    popularity: 85,
  },
  {
    id: "a07",
    name: "桐谷玲奈",
    nameRomaji: "Kiritani Rena",
    nameKana: "きりたに れな",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20thirties%20with%20long%20straight%20hair%20and%20a%20fringe%2C%20wearing%20a%20soft%20grey%20turtleneck%2C%20warm%20stone%20colored%20seamless%20studio%20background%2C%20gentle%20rim%20lighting%2C%20quiet%20editorial%20fashion%20photography%2C%20soft%20neutral%20makeup%2C%20calm%20gaze&width=600&height=800&seq=actress-portrait-07&orientation=portrait",
    birthDate: "1993-12-05",
    age: 32,
    debutYear: 2014,
    status: "活跃",
    agency: "樱坂事务所",
    height: "160cm",
    hometown: "千叶县",
    genres: ["青春", "文艺剧情"],
    featuredWorks: ["樱花落下的那天"],
    bio: "以温柔声线与邻家气质被观众记住，长期出演青春与家庭题材。近年尝试制片助理工作，参与小成本短片的企划与选角。",
    worksCount: 78,
    popularity: 81,
  },
  {
    id: "a08",
    name: "早川结衣",
    nameRomaji: "Hayakawa Yui",
    nameKana: "はやかわ ゆい",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20twenties%20with%20a%20short%20bob%20and%20airy%20bangs%2C%20wearing%20a%20pale%20peach%20blouse%2C%20soft%20blush%20beige%20studio%20backdrop%2C%20bright%20diffused%20daylight%20look%2C%20youthful%20minimal%20magazine%20portrait%2C%20bright%20natural%20expression%2C%20fine%20grain&width=600&height=800&seq=actress-portrait-08&orientation=portrait",
    birthDate: "2002-04-21",
    age: 24,
    debutYear: 2021,
    status: "活跃",
    agency: "星野企划",
    height: "157cm",
    hometown: "埼玉县",
    genres: ["青春", "爱情喜剧"],
    featuredWorks: ["夏日祭典之后", "第七次告白"],
    bio: "从短视频与广告模特起步的新生代，镜头前反应轻快，喜剧节奏感突出。目前正在尝试更具挑战性的群像剧角色。",
    worksCount: 36,
    popularity: 87,
  },
  {
    id: "a09",
    name: "小野寺枫",
    nameRomaji: "Onodera Kaede",
    nameKana: "おのでら かえで",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20late%20twenties%20with%20tucked%20behind%20ear%20dark%20hair%2C%20wearing%20a%20sleeveless%20olive%20top%20with%20a%20light%20cardigan%2C%20warm%20olive%20grey%20studio%20background%2C%20soft%20cinematic%20lighting%2C%20restrained%20editorial%20photography%2C%20gentle%20composed%20smile%2C%20subtle%20texture&width=600&height=800&seq=actress-portrait-09&orientation=portrait",
    birthDate: "1997-02-08",
    age: 29,
    debutYear: 2017,
    status: "活跃",
    agency: "白鹭制作",
    height: "164cm",
    hometown: "爱知县",
    genres: ["群像", "美食", "都市情感"],
    featuredWorks: ["深夜食堂物语", "东京的四个季节"],
    bio: "擅长在群像作品中以细节演出建立角色记忆点，是深夜档电视剧的常客。业余热爱料理，常在采访中分享剧组便当企划。",
    worksCount: 71,
    popularity: 86,
  },
  {
    id: "a10",
    name: "樱井望",
    nameRomaji: "Sakurai Nozomi",
    nameKana: "さくらい のぞみ",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20thirties%20with%20a%20soft%20updo%20hairstyle%2C%20wearing%20a%20dusty%20rose%20silk%20blouse%2C%20warm%20rose%20beige%20studio%20backdrop%2C%20soft%20window%20light%2C%20timeless%20film%20portrait%20photography%2C%20serene%20elegant%20expression%2C%20delicate%20grain&width=600&height=800&seq=actress-portrait-10&orientation=portrait",
    birthDate: "1993-06-16",
    age: 33,
    debutYear: 2013,
    status: "活跃",
    agency: "东洋艺能",
    height: "167cm",
    hometown: "兵库县",
    genres: ["文艺剧情", "青春", "时代剧"],
    featuredWorks: ["樱花落下的那天", "雪国来信"],
    bio: "以古典气韵与稳定的台词功底著称，多次出演以昭和年代为背景的作品。近年参与朗读剧与电台节目，拓展声音领域的表现。",
    worksCount: 94,
    popularity: 83,
  },
  {
    id: "a11",
    name: "藤井纱良",
    nameRomaji: "Fujii Sara",
    nameKana: "ふじい さら",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20twenties%20with%20long%20wavy%20hair%2C%20wearing%20a%20simple%20white%20shirt%2C%20pale%20sand%20studio%20background%2C%20soft%20clean%20beauty%20lighting%2C%20fresh%20minimal%20portrait%20photography%2C%20bright%20honest%20expression%2C%20subtle%20film%20grain&width=600&height=800&seq=actress-portrait-11&orientation=portrait",
    birthDate: "2004-08-12",
    age: 22,
    debutYear: 2022,
    status: "活跃",
    agency: "樱坂事务所",
    height: "161cm",
    hometown: "静冈县",
    genres: ["犯罪", "青春", "文艺剧情"],
    featuredWorks: ["静默的证词", "白夜的花火"],
    bio: "新人阶段便获得重要配角的关注，气质干净、表演直接。被导演评价为「镜头一开就会自己长出细节」的演员，后续作品备受期待。",
    worksCount: 24,
    popularity: 88,
  },
  {
    id: "a12",
    name: "长谷川凛",
    nameRomaji: "Hasegawa Rin",
    nameKana: "はせがわ りん",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20mid%20thirties%20with%20sleek%20dark%20hair%20pulled%20back%2C%20wearing%20a%20charcoal%20kimono%20style%20jacket%2C%20muted%20warm%20taupe%20studio%20background%2C%20dramatic%20soft%20side%20light%2C%20refined%20cinematic%20portrait%2C%20poised%20sophisticated%20expression%2C%20fine%20texture&width=600&height=800&seq=actress-portrait-12&orientation=portrait",
    birthDate: "1990-10-03",
    age: 36,
    debutYear: 2011,
    status: "活跃",
    agency: "白鹭制作",
    height: "170cm",
    hometown: "石川县",
    genres: ["时代剧", "治愈", "群像"],
    featuredWorks: ["京都夜行", "海边的旧书店"],
    bio: "出道十五年，以时代剧中的沉稳演出建立口碑。长期居住在关西，参与多部以京都为舞台的作品，并担任地方文化节目的旁白。",
    worksCount: 118,
    popularity: 84,
  },
  {
    id: "a13",
    name: "宫下遥",
    nameRomaji: "Miyashita Haruka",
    nameKana: "みやした はるか",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20twenties%20with%20natural%20black%20hair%20and%20light%20fringe%2C%20wearing%20a%20soft%20cream%20cardigan%20over%20a%20white%20tee%2C%20warm%20ivory%20studio%20backdrop%2C%20gentle%20diffused%20lighting%2C%20youthful%20editorial%20portrait%2C%20shy%20warm%20smile%2C%20film%20grain&width=600&height=800&seq=actress-portrait-13&orientation=portrait",
    birthDate: "2005-01-19",
    age: 21,
    debutYear: 2023,
    status: "活跃",
    agency: "星野企划",
    height: "159cm",
    hometown: "宫城县",
    genres: ["青春", "爱情喜剧", "都市情感"],
    featuredWorks: ["第七次告白", "六本木的黄昏"],
    bio: "2005 年出生的新生代，从地方选拔中脱颖而出。以自然不做作的表演方式获得关注，目前仍在校就读，作品以青春题材为主。",
    worksCount: 18,
    popularity: 79,
  },
  {
    id: "a14",
    name: "相泽未来",
    nameRomaji: "Aizawa Mirai",
    nameKana: "あいざわ みらい",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20late%20twenties%20with%20a%20messy%20low%20bun%2C%20wearing%20a%20muted%20terracotta%20knit%20sweater%2C%20warm%20clay%20studio%20background%2C%20soft%20natural%20lighting%2C%20relaxed%20lifestyle%20magazine%20portrait%2C%20gentle%20thoughtful%20expression%2C%20subtle%20texture&width=600&height=800&seq=actress-portrait-14&orientation=portrait",
    birthDate: "1998-02-27",
    age: 28,
    debutYear: 2018,
    status: "活跃",
    agency: "蓝光娱乐",
    height: "162cm",
    hometown: "广岛县",
    genres: ["治愈", "文艺剧情", "都市情感"],
    featuredWorks: ["玻璃与光", "旅行的意义"],
    bio: "擅长生活化表演，作品多为旅途与日常题材。参与过多部地方合作电影，喜欢以散步的方式熟悉拍摄地，被剧组称为「地图收藏家」。",
    worksCount: 57,
    popularity: 80,
  },
  {
    id: "a15",
    name: "佐仓朋美",
    nameRomaji: "Sakura Tomomi",
    nameKana: "さくら ともみ",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20thirties%20with%20soft%20layered%20hair%2C%20wearing%20a%20light%20grey%20blazer%20over%20a%20silk%20camisole%2C%20warm%20greige%20studio%20backdrop%2C%20flattering%20soft%20light%2C%20polished%20editorial%20photography%2C%20warm%20confident%20expression%2C%20delicate%20film%20grain&width=600&height=800&seq=actress-portrait-15&orientation=portrait",
    birthDate: "1995-07-07",
    age: 31,
    debutYear: 2015,
    status: "活跃",
    agency: "樱坂事务所",
    height: "164cm",
    hometown: "东京都",
    genres: ["剧情", "都市情感", "青春"],
    featuredWorks: ["三个人的夏天", "她的第二个名字"],
    bio: "都市情感题材的常客，擅长呈现关系中的细微张力。近年参与剧本朗读会与新人演技工作坊，被视为剧组中的稳定力量。",
    worksCount: 82,
    popularity: 82,
  },
  {
    id: "a16",
    name: "东云澪",
    nameRomaji: "Shinonome Mio",
    nameKana: "しののめ みお",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20mid%20twenties%20with%20straight%20shoulder-length%20hair%2C%20wearing%20a%20soft%20slate%20blue%20grey%20shirt%2C%20warm%20grey%20beige%20studio%20background%2C%20quiet%20directional%20lighting%2C%20cool%20minimal%20portrait%20photography%2C%20calm%20reserved%20gaze%2C%20fine%20grain&width=600&height=800&seq=actress-portrait-16&orientation=portrait",
    birthDate: "2001-06-08",
    age: 25,
    debutYear: 2020,
    status: "活跃",
    agency: "东洋艺能",
    height: "166cm",
    hometown: "福井县",
    genres: ["悬疑", "治愈", "剧情"],
    featuredWorks: ["无声的房间", "旅行的意义"],
    bio: "以安静的镜头存在感见长，常在悬疑作品中出演掌握关键线索的角色。私下喜欢摄影，曾为剧组拍摄幕后记录。",
    worksCount: 43,
    popularity: 78,
  },
  {
    id: "a17",
    name: "冈田奈绪",
    nameRomaji: "Okada Nao",
    nameKana: "おかだ なお",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20late%20twenties%20with%20a%20blunt%20bob%20and%20middle%20part%2C%20wearing%20a%20muted%20sage%20green%20blouse%2C%20warm%20khaki%20beige%20studio%20backdrop%2C%20soft%20even%20studio%20light%2C%20understated%20editorial%20portrait%2C%20serious%20focused%20expression%2C%20subtle%20texture&width=600&height=800&seq=actress-portrait-17&orientation=portrait",
    birthDate: "1997-11-23",
    age: 29,
    debutYear: 2019,
    status: "活跃",
    agency: "白鹭制作",
    height: "163cm",
    hometown: "长野县",
    genres: ["犯罪", "悬疑", "群像"],
    featuredWorks: ["静默的证词"],
    bio: "擅长刑侦与法庭题材，为角色进行过大量案头研究。以克制的表演方式呈现职业女性的强度，是近年犯罪题材的常见面孔。",
    worksCount: 55,
    popularity: 77,
  },
  {
    id: "a18",
    name: "川岛诗织",
    nameRomaji: "Kawashima Shiori",
    nameKana: "かわしま しおり",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20thirties%20with%20a%20soft%20chignon%20and%20loose%20strands%2C%20wearing%20a%20deep%20olive%20silk%20dress%2C%20warm%20sand%20studio%20background%2C%20warm%20cinematic%20lighting%2C%20classic%20portrait%20photography%2C%20graceful%20composed%20expression%2C%20fine%20film%20grain&width=600&height=800&seq=actress-portrait-18&orientation=portrait",
    birthDate: "1996-03-02",
    age: 30,
    debutYear: 2016,
    status: "活跃",
    agency: "星野企划",
    height: "165cm",
    hometown: "奈良县",
    genres: ["时代剧", "文艺剧情"],
    featuredWorks: ["京都夜行"],
    bio: "奈良出身，长期参与关西取景的时代剧拍摄。擅长和服身段与古典台词，同时在现代剧中展现温柔的母亲或姐姐形象。",
    worksCount: 61,
    popularity: 74,
  },
  {
    id: "a19",
    name: "北村优香",
    nameRomaji: "Kitamura Yuka",
    nameKana: "きたむら ゆうか",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20thirties%20with%20wavy%20medium%20hair%2C%20wearing%20a%20soft%20cream%20turtleneck%20sweater%2C%20warm%20oatmeal%20studio%20background%2C%20soft%20wrapped%20light%2C%20cozy%20editorial%20photography%2C%20friendly%20warm%20smile%2C%20subtle%20grain&width=600&height=800&seq=actress-portrait-19&orientation=portrait",
    birthDate: "1993-05-11",
    age: 33,
    debutYear: 2014,
    status: "活跃",
    agency: "蓝光娱乐",
    height: "161cm",
    hometown: "新潟县",
    genres: ["群像", "美食", "剧情"],
    featuredWorks: ["深夜食堂物语", "三个人的夏天"],
    bio: "以亲和力强的表演风格活跃于家庭与美食题材，是长寿剧集的常驻演员之一。喜欢在新潟老家种植香草，并分享料理食谱。",
    worksCount: 88,
    popularity: 76,
  },
  {
    id: "a20",
    name: "松本真白",
    nameRomaji: "Matsumoto Mashiro",
    nameKana: "まつもと ましろ",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20twenties%20with%20long%20straight%20dark%20hair%2C%20wearing%20a%20minimal%20white%20dress%20shirt%2C%20pale%20warm%20grey%20studio%20backdrop%2C%20bright%20soft%20daylight%2C%20clean%20modern%20portrait%20photography%2C%20gentle%20honest%20expression%2C%20fine%20texture&width=600&height=800&seq=actress-portrait-20&orientation=portrait",
    birthDate: "2002-09-14",
    age: 24,
    debutYear: 2022,
    status: "活跃",
    agency: "樱坂事务所",
    height: "158cm",
    hometown: "群马县",
    genres: ["治愈", "青春", "文艺剧情"],
    featuredWorks: ["雪国来信", "旅行的意义"],
    bio: "以干净的气质与内敛表演受到文艺片导演青睐，作品多与自然风景结合。喜欢写随笔，在个人专栏记录拍摄途中的见闻。",
    worksCount: 27,
    popularity: 73,
  },
  {
    id: "a21",
    name: "森川千寻",
    nameRomaji: "Morikawa Chihiro",
    nameKana: "もりかわ ちひろ",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20late%20twenties%20with%20a%20soft%20bob%20and%20side%20part%2C%20wearing%20a%20soft%20mustard%20cardigan%2C%20warm%20sand%20beige%20studio%20background%2C%20gentle%20diffused%20lighting%2C%20warm%20editorial%20portrait%2C%20quiet%20kind%20smile%2C%20subtle%20film%20grain&width=600&height=800&seq=actress-portrait-21&orientation=portrait",
    birthDate: "1997-04-06",
    age: 29,
    debutYear: 2017,
    status: "活跃",
    agency: "白鹭制作",
    height: "160cm",
    hometown: "熊本县",
    genres: ["群像", "美食", "治愈"],
    featuredWorks: ["深夜食堂物语"],
    bio: "擅长在群像剧中塑造鲜明的小人物，喜剧与温情场面都能自然承接。积极参与地方广播节目，拥有稳定的听众群。",
    worksCount: 66,
    popularity: 72,
  },
  {
    id: "a22",
    name: "吉泽瞳",
    nameRomaji: "Yoshizawa Hitomi",
    nameKana: "よしざわ ひとみ",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20mid%20thirties%20with%20a%20short%20polished%20haircut%2C%20wearing%20a%20deep%20brown%20tailored%20jacket%2C%20warm%20taupe%20grey%20studio%20backdrop%2C%20soft%20dramatic%20lighting%2C%20mature%20editorial%20portrait%2C%20composed%20dignified%20expression%2C%20fine%20grain&width=600&height=800&seq=actress-portrait-22&orientation=portrait",
    birthDate: "1991-08-25",
    age: 35,
    debutYear: 2012,
    status: "休业",
    agency: "东洋艺能",
    height: "167cm",
    hometown: "神奈川县",
    genres: ["都市情感", "剧情"],
    featuredWorks: ["六本木的黄昏"],
    bio: "2012 年出道，以都市题材中的成熟女性形象被观众熟知。2024 年宣布暂时休业，专注家庭与幕后企划工作，作品仍在各平台持续被讨论。",
    worksCount: 91,
    popularity: 70,
  },
  {
    id: "a23",
    name: "大岛纱英",
    nameRomaji: "Oshima Sae",
    nameKana: "おおしま さえ",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20early%20twenties%20with%20a%20playful%20half%20up%20hairstyle%2C%20wearing%20a%20light%20peach%20knit%20vest%2C%20warm%20cream%20studio%20background%2C%20bright%20soft%20lighting%2C%20fresh%20youthful%20editorial%20portrait%2C%20cheerful%20expression%2C%20fine%20film%20grain&width=600&height=800&seq=actress-portrait-23&orientation=portrait",
    birthDate: "2004-12-01",
    age: 22,
    debutYear: 2023,
    status: "活跃",
    agency: "星野企划",
    height: "156cm",
    hometown: "冲绳县",
    genres: ["青春", "爱情喜剧"],
    featuredWorks: ["夏日祭典之后"],
    bio: "冲绳出身的新人，带着南国气质的明亮能量进入影视圈。作品以青春群像为主，正在接受系统的台词与身段训练。",
    worksCount: 14,
    popularity: 68,
  },
  {
    id: "a24",
    name: "篠田丽奈",
    nameRomaji: "Shinoda Rena",
    nameKana: "しのだ れな",
    portrait: "https://readdy.ai/api/search-image?query=Elegant%20editorial%20portrait%20of%20a%20Japanese%20woman%20in%20her%20mid%20twenties%20with%20a%20sleek%20low%20ponytail%2C%20wearing%20a%20fitted%20taupe%20blazer%2C%20warm%20stone%20grey%20studio%20backdrop%2C%20crisp%20soft%20lighting%2C%20modern%20professional%20editorial%20portrait%2C%20confident%20composed%20expression%2C%20subtle%20texture&width=600&height=800&seq=actress-portrait-24&orientation=portrait",
    birthDate: "2000-10-18",
    age: 26,
    debutYear: 2021,
    status: "活跃",
    agency: "蓝光娱乐",
    height: "164cm",
    hometown: "冈山县",
    genres: ["犯罪", "悬疑", "都市情感"],
    featuredWorks: ["静默的证词"],
    bio: "近年活跃于犯罪与法庭题材，以清晰有力的台词见长。大学时期主修法律，为角色提供了扎实的背景知识。",
    worksCount: 33,
    popularity: 71,
  },
];